module.exports = __webpack_public_path__ + "img/ADavis.84d24433.jpg";